<template>
    <CardView title="Projects" ttyId="24" :filterControls="filterControls"></CardView>
</template>

<script>
    import CardView from '@/components/CardView.vue'
    export default {
        name: 'ProjectCards',
        components: {
            CardView
        },
        data() {
            return {
                filterControls: [{ matId: 853 }, { matId: 855 }]
            }
        },
    }
</script>
<style scoped>
</style>
